"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraTabs = void 0;
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
require("../styles/eura-tabs.css");
/**
 * Wrapperi AntD:n Tabs-komponentin ympärille
 */
const EuraTabs = (props) => {
    const { children, className, tabBarGutter, type } = props, other = __rest(props, ["children", "className", "tabBarGutter", "type"]);
    const classConstruct = ['eura-tabs--container', className !== null && className !== void 0 ? className : ''];
    return (react_1.default.createElement(antd_1.Tabs, Object.assign({ type: type !== null && type !== void 0 ? type : 'card', tabBarGutter: tabBarGutter !== null && tabBarGutter !== void 0 ? tabBarGutter : 10, className: classConstruct.join(' ') }, other), children));
};
exports.EuraTabs = EuraTabs;
const Panel = (props) => {
    const { children, className } = props, other = __rest(props, ["children", "className"]);
    const classConstruct = ['eura-tabs-pane', className !== null && className !== void 0 ? className : ''];
    return (react_1.default.createElement(antd_1.Tabs.TabPane, Object.assign({ className: classConstruct.join(' ') }, other), children));
};
const Title = ({ className, isSelected, dataTestId, children, }) => {
    const classConstruct = ['eura-tabs-pane--title', className !== null && className !== void 0 ? className : '', isSelected ? 'eura-tabs-pane--bold' : ''];
    return (react_1.default.createElement("span", { "data-testid": dataTestId, className: classConstruct.join(' ') }, children));
};
exports.EuraTabs.Panel = Panel;
exports.EuraTabs.Title = Title;
